// Display-only reference-number formatting. Stored values are never changed.
// Invoice=I, Quote=Q, Work Order=W, Order=O, Loyalty=L
const PREFIX = { invoice: "I", quote: "Q", workorder: "W", order: "O", loyalty: "L" };

export function refNo(kind, raw) {
  if (raw === null || raw === undefined || String(raw).trim() === "") return "";
  const prefix = PREFIX[kind] || "";
  const s = String(raw).trim();
  const digits = s.replace(/^[A-Za-z]+\s*/, ""); // strip any legacy letter prefix (e.g. "J", "GLA ")
  return prefix + (digits || s);
}
